<h3 style="text-align: center;">{{ui.title}}</h3>
<div energy-report-chart-widget="" x-ng-if="ui.chartData.length>0" data="ui.chartData" unit="ui.chartUnit" style="height: 500px; width:100%;"></div>
